export const environment = {
  production: true,
  captcha: "6LfQpE8UAAAAAFzsUhEJv7ef373o-Gat0F2P5Qhe",
  ssoLogIn: 'https://ssouat.neoffice.app/auth/realms/{clientCode}/protocol/openid-connect/auth?client_id={clientCode}&redirect_uri=https://uat.myatom.app/risksecure/?client={clientCode}&response_type=code&response_mode=fragment',
  ssoLogOut: 'https://ssouat.neoffice.app/auth/realms/{clientCode}/protocol/openid-connect/logout?client_id={clientCode}&redirect_uri=https%3A%2F%2F{clientCode}.neoffice.app',
  baseUrl: "https://ticketuat.neoffice.app/ticket/",
  baseTemplateDownloadUrl: "https://ticketuat.neoffice.app/ticket/assets/excel/"
};